import { c as _c } from "react/compiler-runtime";
import { ListingCardShell, ListingCardImage, ListingCardContent } from "../parts";
import type { VisualType } from "@/lib/types";
export function VendorCard(t0) {
  const $ = _c(16);
  const {
    visual,
    title,
    href,
    market,
    className,
    imageSizes,
    imageCropAspect
  } = t0;
  let t1;
  if ($[0] !== imageCropAspect || $[1] !== imageSizes || $[2] !== visual) {
    t1 = <ListingCardImage visual={visual} sizes={imageSizes} cropAspect={imageCropAspect} />;
    $[0] = imageCropAspect;
    $[1] = imageSizes;
    $[2] = visual;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== title) {
    t2 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== market) {
    t3 = market && <p className="typography-component-xs-regular text-text-secondary desktop:typography-component-sm-regular">{market}</p>;
    $[6] = market;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <ListingCardContent gapClass="gap-2">{t2}{t3}</ListingCardContent>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== className || $[12] !== href || $[13] !== t1 || $[14] !== t4) {
    t5 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t1}{t4}</ListingCardShell>;
    $[11] = className;
    $[12] = href;
    $[13] = t1;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}